







































































































































import { Component, Vue } from 'vue-property-decorator'
import { LoginInfoItemType } from '../../types/type'
import { UserModule } from '../../store'
import { decode } from 'js-base64'
@Component({
  name: 'Login'
})
export default class Login extends Vue {
  public loginChangeClassFlag: boolean = false
  public angelFlag: boolean = true
  public loginListInfo: Array<LoginInfoItemType> = [
    {
      type: 'userName',
      title: '用户名 / Username',
      placeholder: '请输入用户名',
      content: '',
      'show-password': false
    },
    {
      type: 'Password',
      title: '密码 / Password',
      placeholder: '请输入密码',
      content: '',
      'show-password': true
    }
  ]
  public fatherBoxForBgcLeft: string = '0%'
  public fatherBoxForBgcTransition = 'all 5s ease'

  get thisYear (): number {
    return new Date().getFullYear()
  }

  get flagForCanLogin () {
    return this.loginListInfo.some(item => {
      if (!item.content) {
        return true
      }
    })
  }

  mounted () {
    this.flyGraceful()
    const timerIdForMoveForFatherBoxForBgc = setInterval(() => {
      this.moveForFatherBoxForBgc()
    }, 100000)
    this.$on('hook:beforeDestroy', () => {
      timerIdForMoveForFatherBoxForBgc && clearInterval(timerIdForMoveForFatherBoxForBgc)
    })
  }

  liMouseEnter (event) {
    if (this.flagForCanLogin) return
    event.target.classList.add('li_hover')
  }

  liMouseLeave (event) {
    if (this.flagForCanLogin) return
    event.target.classList.remove('li_hover')
  }

  over () {
    this.loginChangeClassFlag = true
    this.angelFlag = false
  }

  leave () {
    this.loginChangeClassFlag = false
    this.angelFlag = true
  }

  getAuthorityList (authoritys) {
    let map = new Map()
    map.set(1, 0)
    map.set(2, 1)
    map.set(4, 2)
    map.set(8, 3)
    map.set(16, 4)
    map.set(32, 5)
    map.set(64, 6)
    map.set(128, 7)
    map.set(256, 8)
    map.set(512, 9)
    map.set(1024, 10)
    map.set(2048, 11)
    map.set(4096, 12)
    map.set(8192, 13)
    map.set(16384, 14)
    map.set(32768, 15)
    map.set(65536, 16)
    map.set(131072, 17)
    map.set(262144, 18)
    map.set(524288, 19)
    map.set(1048576, 20)
    map.set(2097152, 21)
    map.set(4194304, 22)
    map.set(8388608, 23)
    map.set(16777216, 24)
    map.set(33554432, 25)
    map.set(67108864, 26)
    map.set(134217728, 27)
    map.set(268435456, 28)
    map.set(536870912, 29)
    map.set(1073741824, 30)
    map.set(-2147483648, 31)
    var arr = authoritys
    var newArr = []
    for (var i = 0, len = arr.length; i < len; i++) {
      var num = i << 5
      // arr[i] &= (1 << 32) - 1;
      while (arr[i] != 0) {
        var auth = arr[i] & -arr[i]
        arr[i] ^= auth
        newArr.push(num + map.get(auth))
      }
    }
    return newArr
  }

  // 登录或者注册：
  async loginOrRegisterConfirm () {
    try {
      const _that: any = this
      let whoEmpty = {}
      const isEmptyResult = this.loginListInfo.some(item => {
        if (!item.content) {
          whoEmpty = item
          return true
        }
      })
      if (isEmptyResult) return this.$message.error((whoEmpty as LoginInfoItemType).placeholder)
      const params = {
        type: 0,
        account: this.loginListInfo[0].content,
        password: this.loginListInfo[1].content
      }
      let { data: result } = await _that.$http.login(params)
      if (result.code !== 200) return this.$message.error(result.msg)
      let token = result.data
      let userInfo = JSON.parse(
        JSON.parse(decode(result.data.split('.')[1])).user
      )
      let resultAuthorityList = this.getAuthorityList(userInfo.authoritys)
      userInfo['resultAuthorityList'] = resultAuthorityList
      UserModule.setTokenForUser(token)
      UserModule.setUserInfoForUser(userInfo)
      this.$message.success('登录成功')
      setTimeout(() => {
        this.$router.push('/')
      }, 1000)
    } catch (err) {
      console.log(err)
    }
  }

  // logo run：
  flyGraceful () {
    // 获取页面滚动距离的浏览器兼容性问题,获取页面滚动出去的距离
    function getScroll () {
      let scrollLeft = document.body.scrollLeft || document.documentElement.scrollLeft
      let scrollTop = document.body.scrollTop || document.documentElement.scrollTop
      return {
        scrollLeft,
        scrollTop
      }
    }
    // 获取鼠标在页面的位置，处理浏览器兼容性
    function getPage (e) {
      let pageX = e.pageX || e.clientX + getScroll().scrollLeft
      let pageY = e.pageY || e.clientY + getScroll().scrollTop
      return {
        pageX,
        pageY
      }
    }
    // run：
    const angelImg = this.$refs.angelImg
    document.onmousemove = (e: Event) => {
      e = e || window.event
      ;(angelImg as HTMLElement).style.left = getPage(e).pageX + 'px'
      ;(angelImg as HTMLElement).style.top = getPage(e).pageY + 'px'
    }
  }

  downloadChrome (): void {
    window.open('https://www.google.cn/chrome/', '_blank')
  }

  moveForFatherBoxForBgc () {
    switch (this.fatherBoxForBgcLeft) {
      case '0%':
        this.fatherBoxForBgcLeft = '-100%'
        this.fatherBoxForBgcTransition = 'all 5s ease'
        break
      case '-100%':
        this.fatherBoxForBgcLeft = '-200%'
        this.fatherBoxForBgcTransition = 'all 5s ease'
        setTimeout(() => {
          this.fatherBoxForBgcLeft = '0%'
          this.fatherBoxForBgcTransition = 'all 0s'
        }, 5000)
        break
    }
  }

  handleIcp (): void {
    window.open('https://beian.miit.gov.cn/')
  }
}
